import { Abstract } from "lamina/vanilla";
import { Color, Vector2 } from "three";
import chaosFrag from "../../shaders/chaos/frag.glsl"
import chaosVert from "../../shaders/chaos/vert.glsl"

// Extend the Abstract layer
export class Chaos extends Abstract {
  static u_Time = 0;
  static u_Amp = 0.15 / Math.max(2 - 1, 1.0);
  static u_Light1Color = new Color("#acdcf0");
  static u_Light2Color = new Color("#fcd7e4");
  static u_FresnelColor = new Color("#ffff00");
  static u_LightIntensity = [1, 1];
  static u_Color = new Color("#656565");
  static u_Detail = (0.35 * 0.25) / Math.max(2 - 1, 1.0);
  static u_FbmOctaves = 2.0;
  static u_Resolution = new Vector2(200, 200);


  static u_lacunarity = 2.5;
  static u_gain = 0.5;
  static u_colorA = new Color("#1100ff");
  static u_colorB = new Color("#a491de");
  static u_cloudTint = new Color("#ffff00");



  // Define your fragment shader just like you already do!
  // Only difference is, you must return the final color of this layer
  static fragmentShader = chaosFrag;

  // Optionally Define a vertex shader!
  // Same rules as fragment shaders, except no blend modes.
  // Return a non-projected vec3 position.
  static vertexShader = chaosVert;

  constructor(props) {
    // You MUST call `super` with the current constructor as the first argument.
    // Second argument is optional and provides non-uniform parameters like blend mode, name and visibility.
    super(Chaos, {
      name: "Chaos",
      ...props,
    });
  }
}
